import { Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide, useSwiper } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { ref } from "vue";
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    slides: Array
  },
  data() {
    return {
      slidesCount: 4
    };
  },
  methods: {},
  setup() {
    const prev = ref(null);
    const next = ref(null);
    const pagination = ref(null);
    return {
      modules: [Pagination, Navigation],
      prev,
      next,
      pagination
    };
  }
};